// extracted by mini-css-extract-plugin
export default {"footerContainer":"form-footer_footerContainer__ANmZb","footerMain":"form-footer_footerMain__Wcw0N"};